import SearchIcon from '@mui/icons-material/Search';
import { Autocomplete, FormControlLabel, Grid, Switch, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';
import { MyMButton } from '../ui-elements/MyMButton';
import { MyMTooltip } from '../ui-elements/MyMToolTip';
import React, { useState, useRef, useEffect } from 'react';
import { Box } from '@mui/material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { mediaQuery, useMediaQuery } from '../hooks/useMediaQuery';

/**
 * 検索バー Component
 */
const SearchBar = (props) => {

  const {
    textSx,
    optionList,
    searchValue,
    setSearchValue,
    onFocusSearchBar,
    onBlurSearchBar,
    onSearch,
    searchText,
    // 2024.12.23 MyMine Version2.1対応 Add Start
    controlSettings,
    isAdvancedCheck,
    setIsAdvancedCheck
    // 2024.12.23 MyMine Version2.1対応 Add End
  } = props;

  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const tooltipRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setIsTooltipVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleTooltipToggle = () => {
    setIsTooltipVisible(!isTooltipVisible);
  };
  const isPc = useMediaQuery(mediaQuery.pc);

  // 2024.12.23 MyMine Version2.1対応 Modify Start
  return (
    <Grid container spacing={1}>
      {isPc ?
        <>
          <Grid item xs={12} className="d-flex align-items-center ">
            <Autocomplete
              popupIcon={null}
              size="small"
              freeSolo
              options={optionList ?? []}
              sx={{
                '&.MuiAutocomplete-root fieldset': {
                  border: 0,
                },
                '.MuiFormControl-root': {
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                  border: '1px solid #FFF',
                },
                ...textSx
              }}
              value={null}
              inputValue={searchValue}
              onInputChange={(event, newInputValue) => {
                setSearchValue(newInputValue)
              }}
              renderInput={(params) => <TextField {...params}
                onKeyPress={e => {
                  if (e.charCode === 13) { // Enter
                    onSearch(e);
                  }
                }}
                onFocus={onFocusSearchBar}
                onBlur={onBlurSearchBar}
                // 2024.5.8 MyMine Version1.5対応 Modify Start
                inputProps={{ ...params.inputProps, maxLength: 80 }}
              // 2024.5.8 MyMine Version1.5対応 Modify End
              />}
            />
            <MyMButton onClick={onSearch} sx={{ borderRadius: '0px 15px 15px 0px', left: -0.8, height: 42 }}>{searchText}<SearchIcon /></MyMButton>
            <Grid sx={{ textAlign: 'center', alignItems: 'center' }}>
              <CustomWidthTooltip
                title={controlSettings.LabelList.lblAdvancedSearchTooltip}
                arrow
              >
                <Grid sx={{ alignItems: 'center' }}>
                  <FormControlLabel
                    sx={{ color: 'white', marginLeft: '5px' }}
                    control={<AdvancedSwitch sx={{ marginLeft: 1 }} checked={isAdvancedCheck} onChange={(e) => { setIsAdvancedCheck(e.target.checked) }} />}
                    label={controlSettings.LabelList.lblAdvancedSearch}
                    labelPlacement="start"
                  />
                  <Grid sx={{ display: { xs: 'block', md: 'none' }, marginLeft: 3 }}>
                    <MyMTooltip
                      title={controlSettings.LabelList.lblAdvancedSearchTooltip}
                      open={isTooltipVisible}
                    >
                      <Box
                        ref={tooltipRef}
                        component="span"
                        sx={{ cursor: 'pointer' }}
                        onClick={handleTooltipToggle}
                      >
                        <HelpOutlineOutlinedIcon sx={{
                          color: 'white',
                          fontSize: '24px',
                        }} />
                      </Box>
                    </MyMTooltip>
                  </Grid>
                </Grid>
              </CustomWidthTooltip>
            </Grid>
          </Grid>
        </>
        :
        <>
          <Grid container item xs={12} sx={{ display: 'flex', alignItems: 'center'}}>
            <Grid container item xs={12} wrap="nowrap">
              <Grid item xs={12}>
                <Autocomplete
                  popupIcon={null}
                  size="small"
                  freeSolo
                  options={optionList ?? []}
                  sx={{
                    '&.MuiAutocomplete-root fieldset': {
                      border: 0,
                    },
                    '.MuiFormControl-root': {
                      borderTopRightRadius: 0,
                      borderBottomRightRadius: 0,
                      border: '1px solid #FFF',
                    },
                    ...textSx
                  }}
                  value={null}
                  inputValue={searchValue}
                  onInputChange={(event, newInputValue) => {
                    setSearchValue(newInputValue)
                  }}
                  renderInput={(params) => <TextField {...params}
                    onKeyPress={e => {
                      if (e.charCode === 13) { // Enter
                        onSearch(e);
                      }
                    }}
                    onFocus={onFocusSearchBar}
                    onBlur={onBlurSearchBar}
                    inputProps={{ ...params.inputProps, maxLength: 80 }}
                  />}
                />
              </Grid>
              <Grid item>
                <MyMButton onClick={onSearch} sx={{ borderRadius: '0px 15px 15px 0px', height: 42 }}>{searchText}<SearchIcon /></MyMButton>
              </Grid>
            </Grid>
            <Grid sx={{ marginLeft: 'auto', padding: '5px 5px' }}>
              <CustomWidthTooltip
                title={controlSettings.LabelList.lblAdvancedSearchTooltip}
                arrow
              >
                <Grid container>
                  <Grid item sx={{ alignItems: 'center', textAlign: 'center' }}>
                    <FormControlLabel
                      sx={{ color: 'white', }}
                      control={<AdvancedSwitch sx={{ marginLeft: 1 }} checked={isAdvancedCheck} onChange={(e) => { setIsAdvancedCheck(e.target.checked) }} />}
                      label={controlSettings.LabelList.lblAdvancedSearch}
                      labelPlacement="start"
                    />
                  </Grid>
                  <Grid item sx={{ display: { md: 'none' }, marginLeft: 3 }}>
                    <MyMTooltip
                      title={controlSettings.LabelList.lblAdvancedSearchTooltip}
                      open={isTooltipVisible}
                    >
                      <Grid
                        ref={tooltipRef}
                        component="span"
                        sx={{ cursor: 'pointer' }}
                        onClick={handleTooltipToggle}
                      >
                        <HelpOutlineOutlinedIcon sx={{
                          color: 'white',
                          fontSize: '24px',
                        }} />
                      </Grid>
                    </MyMTooltip>
                  </Grid>
                </Grid>
              </CustomWidthTooltip>
            </Grid>
          </Grid>
        </>
      }
    </Grid>
  );
  // 2024.12.23 MyMine Version2.1対応 Modify End
};
export default SearchBar;

// 2024.12.23 MyMine Version2.1対応 Add Start
const CustomWidthTooltip = styled(({ className, ...props }) => (
  <MyMTooltip {...props} classes={{ popper: className }} PopperProps={{
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [-10, 0],
        },
      },
    ],
  }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 450,
  },

});

const AdvancedSwitch = styled(Switch)(({ theme }) => ({
  width: 55,
  height: 23,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(32px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#65C466',
        opacity: 1,
        ':before': { content: '"ON"', color: 'white', left: '8px' }
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    ':before': { content: '"OFF"', color: 'black', fontSize: 13, marginTop: '1px', position: 'absolute' }
  },
}));
// 2024.12.23 MyMine Version2.1対応 Add End